import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { WHToastService, WHToastType } from '@workheld/workheld-shared-lib';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  private readonly toastService = inject(WHToastService);
  private readonly popoverEl =
    viewChild.required<ElementRef>('popoverContainer');

  readonly toasts = this.toastService.toasts;
  readonly iconMap: Record<WHToastType, string> = {
    [WHToastType.SUCCESS]: 'check_circle',
    [WHToastType.ERROR]: 'cancel',
    [WHToastType.WARNING]: 'warning',
    [WHToastType.INFO]: 'info',
  };

  constructor() {
    effect(() => {
      const el = this.popoverEl()?.nativeElement;
      if (!el) return;

      if (this.toastService.hasToasts()) {
        try {
          el.showPopover();
        } catch {
          // already open
        }
      } else {
        try {
          el.hidePopover();
        } catch {
          // already hidden
        }
      }
    });
  }

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  pause(id: string): void {
    this.toastService.pause(id);
  }

  resume(id: string): void {
    this.toastService.resume(id);
  }
}
